export default __webpack_public_path__ + "static/media/bra_details2.86778267.webp";